import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    success: (memberName: string) => string | React.ReactNode;
    error: (errorMessage?: string) => string | React.ReactNode;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Success toast message when member role is updated */
            success: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (memberName: string) => __intl__.intl().formatMessage({ id: "useUpdateMembership.success?c=shg60bcoi3fj", defaultMessage: "{memberName}''s role has been updated" }, { memberName: memberName }));
                },
                enumerable: true,
                configurable: true
            },
            /** Error toast message when role update fails */
            error: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (errorMessage?: string) => __intl__.intl().formatMessage({ id: "useUpdateMembership.error?c=3s50d58pdpcnl", defaultMessage: "Unable to update role{errorMessage, select, true {: {errorMessage}} other {}}" }, { errorMessage: errorMessage }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
